import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "stars" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

import { computed, onMounted, ref } from 'vue'
import { getIcon } from '@/helpers/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    rating: { type: Number, required: true}
},
  emits: ['button_click', 'update:rating', 'send_click'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const starSvg = ref<string>()
const starFilledSvg = ref<string>()
const refs = ref< Array<HTMLElement> >([])
const setStarRef = (ref?:HTMLElement | undefined | null) => {
    if(ref && ref.firstChild){
        refs.value.push(ref.firstChild as HTMLElement)
    }
}

onMounted(async () => {
    starSvg.value = await getIcon('1614A', 'icon')
    starFilledSvg.value = await getIcon('1614A', 'star')

    if(starSvg.value){
        // const cssUtils = new CssUtils(starSvg.value)
        // starSvg.value = cssUtils.removeSvgAttribute('fill')
        //                     .addSvgAttribute('fill', 'var(--milage-color-primary)')
        //                     .removeSvgAttribute('width')
        //                     .removeSvgAttribute('height')
        //                     .build()
    }

})


function toggleStarRow(nth:number){
    if(props.rating === nth){
        cleanStarRow('#969696')
        emit('update:rating', 0)
        return
    }
    emit('update:rating', nth)

    cleanStarRow('#969696')
    while(nth > 0){
        setStarColor(refs.value[nth-1], '#00ACDF')
        nth = nth-1
    }
}
function setStarColor(star:HTMLElement, color:string){
    const children = star.children;

    star.setAttribute("fill", color)
    for(let i = 0; i < children.length; i++){
        const c: HTMLElement = children.item(i) as HTMLElement
        c.setAttribute("fill", color)
    }
}
function cleanStarRow(color:string){
    refs.value.forEach((star: HTMLElement) => {
        setStarColor(star, color)
    })
}

const getStarRow = computed(() => false)

/*

<svg fill="#000000" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>star</title> 
    <path d="M3.488 13.184l6.272 6.112-1.472 8.608 7.712-4.064 7.712 4.064-1.472-8.608 6.272-6.112-8.64-1.248-3.872-7.808-3.872 7.808z"></path> </g></svg>

*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (nth, key) => {
      return _createElementVNode("span", {
        class: "star",
        key: key,
        onClick: ($event: any) => (toggleStarRow(nth)),
        ref_for: true,
        ref: el => setStarRef(el as HTMLElement)
      }, [
        _createElementVNode("img", {
          src: nth <= __props.rating ? starSvg.value : starFilledSvg.value
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2)
    }), 64))
  ]))
}
}

})